import React from 'react'
import styled from 'styled-components'

import LocalizedLink from '@/components/localized-link'
import {Text} from '@/components/text'
import {
    ImageContentWrapper,
    ContentWrapper,
    Details,
    DetailsSeparator,
    StyledImage,
} from '@/styles/cards'
import {Section, Layout} from '@/styles/grid'
import mq from '@/utils/media-query'
import {truncate} from '@/utils/truncate'

import type {ImageSource} from '@/types/image'

export interface Props {
    title: string
    items: {
        thumbnail: ImageSource
        title: string
        description: string
        category: string
        duration: string
        uid: string
    }[]
}

export const VideoLibrary = ({title, items}: Props) => (
    <StyledSection>
        <StyledText forwardedAs="h2" $variant="heading-base">
            {title}
        </StyledText>

        <Layout $variant="three-equal">
            {items?.map((item) => (
                <ImageContentWrapper key={item.uid}>
                    {!!item.thumbnail ? (
                        <LocalizedLink to={`/${item.uid}`}>
                            <StyledImage image={item.thumbnail} $hideOnMobile={false} />
                        </LocalizedLink>
                    ) : null}
                    <ContentWrapper>
                        <Details as="p">
                            <Text as="span" $variant="label-base" $color="brand">
                                {item.category}
                            </Text>
                            <DetailsSeparator />
                            <Text as="span" $variant="label-base" $color="lightMuted">
                                {item.duration}
                            </Text>
                        </Details>

                        <LocalizedLink to={`/${item.uid}`}>
                            <Text as="h2">{item.title}</Text>
                        </LocalizedLink>

                        <Text $variant="paragraph-base" $color="lightMuted">
                            {truncate(item.description, 140)}
                        </Text>
                    </ContentWrapper>
                </ImageContentWrapper>
            ))}
        </Layout>
    </StyledSection>
)

const StyledSection = styled(Section)`
    display: grid;
    gap: ${({theme}) => theme.spacings.s20};

    ${mq.min('sm')} {
        gap: ${({theme}) => theme.spacings.s60};
    }
`

const StyledText = styled(Text)`
    ${mq.min('sm')} {
        width: 50%;
    }
`
